import zenScroll from 'zenscroll';

export function handleClickOnDisclaimerLink(e) {
    const clickedElement = String(e.target);
    if (!clickedElement.includes('#disclaimer')) return;

    const elementToScrollTo = document.getElementById('scroll-to-content');
    if (!elementToScrollTo) return;

    zenScroll.to(elementToScrollTo);
}
